export default "__VITE_ASSET__DPyS$8ny__"